import CartMixins from './cartMixins'
import CustomerMixins from './customerMixins'
import PricingMixins from './pricingMixins'
import CatalogMixins from './catalogMixins'
import GlobalMixins from './globalMixins'
import TotalMixins from './totalMixins'

import { deepCopy, buildUrl, getRouteByName, buildRoute, goToUrl, } from '../../helpers'

export default {
    mixins: [
        CartMixins,
        CustomerMixins,
        PricingMixins,
        CatalogMixins,
        GlobalMixins,
        TotalMixins,
    ],
    data() {
        return {
            tmpNbMinLicenses: 2,
            tmpNbLicenses: 2,
            tmpNbLicensesOffered: 0,
            pricingPlanTmp: ''
        }
    },
    methods: {
        deepCopy,
        buildUrl,
        getRouteByName,
        goToUrl,
        buildRoute
    },
}